import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, CircularProgress, FormControl } from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import styled from "styled-components";
import request from "../utils/request";
import { ToastContext } from "./providers/toast-provider";

const CameraPhoto = styled(Button)`
    background-color: ${({ theme }) => theme.palette.background.paper};
    color: ${({ theme }) => theme.palette.text.secondary};
    height: 120px;
    width: 120px;
`;

const Label = styled.label`
    border: ${({ theme, result }) => {
        if (result === "pending") return `2px solid ${theme.palette.text.disabled}`;
        if (result === "success") return `2px solid ${theme.palette.success.main}`;
        if (result === "failure") return `2px solid ${theme.palette.error.main}`;
        return `2px solid transparent`;
    }};
`;

const LoadingDiv = styled.div`
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: black;
    opacity: 0.3;
`;

const Picture = ({ picture, requestUrl, onSuccess }) => {
    // eslint-disable-next-line no-unused-vars
    const { t } = useTranslation();
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const [file, setFile] = useState();
    const [saveResult, setSaveResult] = useState();

    React.useEffect(() => {
        setTimeout(() => {
            if (saveResult === "success" || saveResult === "failure") setSaveResult(undefined);
        }, 500);
    }, [saveResult]);

    const clearValue = (event) => {
        // eslint-disable-next-line no-param-reassign
        event.target.value = null;
    };

    const handleChange = async (event) => {
        const newPicture = {
            url: URL.createObjectURL(event.target.files[0]),
            blob: event.target.files[0],
        };
        if (event.target.files[0].size > 20 * 1024 * 1024) {
            setMessage(`Pictures more than 20mb are not supported`);
            setSeverity("warning");
            setIsToastTriggered(true);
            return;
        }
        setFile(newPicture);
        const formData = new FormData();
        formData.append("picture", newPicture.blob);
        const options = { method: "POST", body: formData, timeout: 2 * 60 * 1000 };
        setSaveResult("pending");
        try {
            await request(requestUrl, options);
            if (onSuccess) await onSuccess();
            setSaveResult("success");
        } catch (e) {
            setFile();
            setSaveResult("failure");
        }
    };

    const renderPicture = () => {
        if (saveResult === "pending") {
            return (
                <>
                    <CircularProgress style={{ position: "absolute", left: "34%" }} />
                    <LoadingDiv />
                    <img
                        src={(file && file.url) || picture}
                        alt="Profile"
                        style={{ borderRadius: "3px", maxWidth: "80px", maxHeight: "80px" }}
                    />
                </>
            );
        }
        return (
            <img
                src={(file && file.url) || picture}
                alt="Profile"
                style={{ borderRadius: "3px", maxWidth: "80px", maxHeight: "80px" }}
            />
        );
    };

    return (
        <FormControl>
            <Label htmlFor="picture" result={saveResult}>
                <CameraPhoto component="label">
                    <>
                        <input
                            type="file"
                            id="picture"
                            hidden
                            accept="image/*"
                            onChange={handleChange}
                            onClick={clearValue}
                        />
                        {file || picture ? renderPicture() : <PhotoCameraIcon />}
                    </>
                </CameraPhoto>
            </Label>
        </FormControl>
    );
};

export default Picture;
